import { useEffect, useState } from "react";
import { Checkbox, Spinner } from "@rio-cloud/rio-uikit";
import { createChannel, IChannel, IMember } from "src/services/amity";
import { Chip } from "@components";
import { Driver, UserChat } from "@types";
import { userSelected } from "src/store/user/userSlice";
import TableChip from "src/components/TableChip";
import Avatar from "src/components/Avatar/indext";

interface INewChatProps {
  handleBackToList: () => void;
  handleOpenMessages: (channel: IChannel) => void;
  userId: string;
  allUsers: UserChat[];
  channels: IChannel[];
}

const NewChat = ({ handleBackToList, handleOpenMessages, userId, allUsers, channels }: INewChatProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [users, setUsers] = useState<UserChat[]>([]);
  const [copyUsers, setCopyUsers] = useState<UserChat[]>([]);
  const [selectedUser, setSelectedUser] = useState<UserChat | null>(null);
  const [selected, setSelected] = useState<number | null>(null);

  useEffect(() => {
    setLoading(true);

    if (allUsers) {
      setUsers(allUsers);
      setCopyUsers(allUsers);
      setLoading(false);
    }
  }, [allUsers]);

  const handleCreateChat = async () => {
    if (selectedUser) {
      const userIdElected = selectedUser.uniqueProfileId ? selectedUser.uniqueProfileId : selectedUser.userId;
      const filterChannel = channels.filter((ch) => ch.members.length === 1 && ch.members?.includes(userIdElected as any));

      if (filterChannel.length > 0) {
        handleOpenMessages({
          ...filterChannel[0],
          profileImage: selectedUser.avatar,
        });
        return;
      }

      const newChannel = await createChannel(
        [
          {
            displayName: selectedUser.name as string,
            userId: userIdElected as string,
            profileImage: selectedUser.avatar,
            // type: selectedUser.type,
          },
        ],
        userId
      );

      handleOpenMessages({
        ...newChannel,
        profileImage: selectedUser.avatar,
      });
    }
  };

  const filterSearchName = (text: string) => {
    if (text && text.length > 0) {
      setUsers(copyUsers.filter((u) => u.name?.toLowerCase()?.includes(text)));
    } else {
      setUsers(copyUsers);
    }
  };

  return (
    <div className="chat-view new-chat display-flex">
      <div className="chat-header display-flex justify-content-between align-items-center bg-always-black text-white">
        <button onClick={handleBackToList} className="bg-always-black border-none">
          <span className="rioglyph rioglyph-arrow-left text-color-primary"></span>
        </button>
        <h3 className="text-size-h4 font-bold insert-title">Nova Mensagem</h3>
      </div>

      <div className="search-field margin-top-10">
        <div className="form-group margin-bottom-0">
          <label className="width-100pct text-color-black text-medium">
            Convidar pessoas
            <input
              className="form-control margin-y-5"
              type="text"
              placeholder="Pesquisar"
              onChange={(e) => filterSearchName(e.target.value)}
            />
            <button className="btn btn-action padding-0">
              {loading ? <Spinner /> : <span className="rioglyph rioglyph-search text-color-primary"></span>}
            </button>
          </label>
        </div>
      </div>

      <div className="p-4 overflow-y-auto flex-1">
        {users?.map((user, idx) => {
          return (
            <div
              key={idx}
              className="display-flex align-items-center justify-content-between card-info"
              onClick={() => {
                setSelectedUser(user);
                setSelected(idx)
              }}
            >
              <div className="display-flex align-items-center">
                <div className="padding-10">
                  <Avatar url={user.avatar as string} />
                </div>
                <div className="display-flex flex-column">
                  <div>
                    <span className="text-color-black text-size-18 text-capitalize">
                      {user.name?.split("__")[0]}
                    </span>

                  </div>
                  <div className="display-flex gap-2">
                    {user.isManager ? (
                      <Chip
                        text="Gestor da frota"
                        icon="rioglyph rioglyph-role-management"
                        background="bg-always-black"
                      />
                    ) : (
                      <Chip
                        text="Minha equipe"
                        icon="rioglyph rioglyph-role-management"
                        background="bg-status-working"
                        disabled={!user.userId}
                      />
                    )}

                    <Chip
                      text="Trucker Assist"
                      icon="rioglyph rioglyph rioglyph-phone"
                      background="bg-status-driving"
                      disabled={!user.uniqueProfileId}
                    />
                  </div>
                </div>
              </div>
              <div>
                <Checkbox
                  iconSize={10}
                  checked={idx === selected}
                  onChange={(e) => {
                    setSelected(idx);
                    if (e.target.checked) {
                      setSelectedUser(user);
                    }
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>

      {loading && <Spinner isDoubleSized />}

      {selectedUser && (
        <div className="shadow-smooth-up">
          {selectedUser.uniqueProfileId ? null : (
            <div className="padding-10 border border-color-light border-bottom-only border-width-1 margin-bottom-10">
              <span className="text-size-14 text-color-danger text-align-center text-normal">
                  Este profissional não está com perfil atualizado no Trucker Assist
              </span>
            </div>
          )}

          <div className="display-flex justify-content-center gap-5 padding-10">
            <button
              type="button"
              className="btn text-color-primary width-100pct height-50"
              onClick={() => {
                setSelectedUser(null);
                setSelected(null);
              }}
            >
              Cancelar
            </button>
            <button
              disabled={!selectedUser.uniqueProfileId}
              type="button"
              className="btn btn-primary width-100pct height-50 border-0"
              onClick={handleCreateChat}
            >
              Criar conversa
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewChat;
